import { Stack, Typography } from '@mui/material';

import { AlgorithmsStatus } from '../../types';

import { Tooltip } from '@/shared/components/tooltip';

interface MediaPlanCellProps {
  algorithmsStatus: AlgorithmsStatus[];
}

const MediaPlanCell = ({ algorithmsStatus }: MediaPlanCellProps) => {
  if (!algorithmsStatus.length) {
    return (
      <Typography
        variant='subtitleNumbers'
        component='span'
        color='textSecondary'
      >
        N/A
      </Typography>
    );
  }

  return (
    <Stack gap={2}>
      {algorithmsStatus.map(({ id, mediaPlan }) => {
        const name = mediaPlan?.name ?? 'None';

        return (
          <Tooltip key={id} title={name} placement='top-start' arrow={false}>
            <Typography
              variant='subtitleNumbers'
              component='span'
              color={mediaPlan ? 'textTertiary' : 'textSecondary'}
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                display: 'block',
              }}
            >
              {name}
            </Typography>
          </Tooltip>
        );
      })}
    </Stack>
  );
};

export default MediaPlanCell;
